<template>
    <div class="TenantPaymentContent">
        <div>
            <div class="buttons">
                <div @click="get_payment_time">
                    <select v-model="select_m" class="select_style">
                        <option style="display:none;" value="null">選擇未繳月份</option>
                        <option v-for="item in select_m_list" :key="item.id" :value="item.id">
                            {{item.payment_time}}
                        </option>
                    </select>
                </div>

                <button @click="produce(select_m)">
                    顯示繳款帳號
                </button>
            </div>
            <hr>
            <div class="table_list">
                <div class="list_title">
                    <h3>繳費紀錄</h3>
                </div>
                <button class="cancel_style" @click="cancel">
                    返回
                </button>
                <table class="table" ref="oTable">
                    <thead>
                        <tr>
                            <th>繳交月份</th>
                            <th>應繳金額</th>
                            <th>已繳金額</th>
                            <!-- <th>聯絡人</th>
                            <th>連絡電話</th> -->
                            <th>帳號</th>
                            <th>狀態</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-show="tenant_payment_content.length > 0" v-for="item in tenant_payment_content" :key="item.id">
                            <td>{{item.payment_time}}</td>
                            <td>{{item.amount_payable}}</td>
                            <td>{{item.actual_payment_amount}}</td>
                            <!-- <td>{{item.emergency_contact}}</td>
                            <td>{{item.emergency_phone}}</td> -->
                            <td>{{item.emergency_phone}}</td>
                            <td :style="item.pay_status == 0 ? 'color:red;' : ''">
                                {{pay_status[item.pay_status]}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="modal fade" v-show="modal_show">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            繳款帳號
                        </h5>
                    </div>
                    <div class="modal-body">
                        <p>
                            帳號:&emsp;{{ virtual_account }}
                        </p>
                        <p>
                            金額:&emsp;{{ Amount_due }}
                        </p>
                        <small class="small_text">
                            *請使用&emsp;ATM轉帳&emsp;或&emsp;網路銀行轉帳&emsp;謝謝您的配合。*
                        </small>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="modal_btn btn-secondary" @click="modal_show = false">關閉</button>
                        <!-- <button type="button" class="modal_btn btn-primary">下載</button> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import "@/assets/css/member/tenantPaymentContent.css";

export default {
    name: 'TenantPaymentContent',
    data() {
        return {
            modal_show: false,
            select_m: null,
            select_m_list: '',
            tenant_payment_content: '',
            pay_status: ['未繳', '已繳'],
            virtual_account: '123',
            Amount_due: '666'
        };
    },
    components: {

    },
    filters: {},
    beforeMount: function () {
        const getData = new FormData();
        getData.append('CMD', 'FrontMemberHomeTenantPaymentContent');
        getData.append('house_number', localStorage.getItem('house_number'))
        this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, getData)
        .then(response => {
            // console.log(response);
            const get_data = response.data.tenant_payment_content;
            if (get_data) {
                this.tenant_payment_content = get_data;
                this.$nextTick(() =>{ //請求成功的回調使用
                    $(this.$refs.oTable).DataTable({
                        searching: false, //搜尋功能, 預設是開啟
                        paging: true, //分頁功能, 預設是開啟
                        ordering: false, //排序功能, 預設是開啟
                        lengthMenu: [10, 20],
                        language: {
                            processing: "處理中...",
                            loadingRecords: "載入中...",
                            lengthMenu: "一頁顯示 _MENU_ 筆",
                            zeroRecords: "沒有數據....",
                            info: "第 _START_ ~ _END_ 筆，共 _TOTAL_ 筆",
                            infoEmpty: "",
                            infoFiltered: "(從 _MAX_ 項結果中過濾)",
                            infoPostFix: "",
                            search: "搜尋:",
                            paginate: {
                                first: "第一頁",
                                previous: "上一頁",
                                next: "下一頁",
                                last: "最後一頁"
                            }
                        }
                    });
                })
            } else {
                console.log(response.data.error);
                this.$nextTick(() =>{ //請求成功的回調使用
                    $(this.$refs.oTable).DataTable({
                        searching: false, //搜尋功能, 預設是開啟
                        paging: true, //分頁功能, 預設是開啟
                        ordering: false, //排序功能, 預設是開啟
                        lengthMenu: [10, 20],
                        language: {
                            processing: "處理中...",
                            loadingRecords: "載入中...",
                            lengthMenu: "一頁顯示 _MENU_ 筆",
                            zeroRecords: "沒有數據....",
                            info: "第 _START_ ~ _END_ 筆，共 _TOTAL_ 筆",
                            infoEmpty: "",
                            infoFiltered: "(從 _MAX_ 項結果中過濾)",
                            infoPostFix: "",
                            search: "搜尋:",
                            paginate: {
                                first: "第一頁",
                                previous: "上一頁",
                                next: "下一頁",
                                last: "最後一頁"
                            }
                        }
                    });
                })
            }
        })
        .catch(error => {
            console.log(error);
        })
    },
    methods: {
        get_payment_time () {
            const get_payment_time = new FormData();
            get_payment_time.append('CMD', 'FrontMemberHomeTenantPaymentContent');
            get_payment_time.append('house_number', localStorage.getItem('house_number'))
            get_payment_time.append('type', 'get_payment_time')
            this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, get_payment_time)
            .then(response => {
                // console.log(response);
                const get_data = response.data.select_m_list;
                if (get_data) {
                    this.select_m_list = get_data;
                } else {
					this.select_m_list = [{'id': 0, 'payment_time':'無未繳月份'}]
                    console.log(response.data.error);
                }
            })
            .catch(error => {
                console.log(error);
            })
        },
        produce (select_m) {
            if (select_m == null) {
                alert('請輸入選擇繳費月份');
            } else if (select_m == 0) {
                alert('無未繳月份');
            } else {
                console.log(select_m);
                this.modal_show = true;
                // alert('開發中');
            }

        },
        cancel () {
            this.$router.push({ name: 'MemberHome'});
        },
    },
    mounted: function () {

    },
    watch: {

    },
    beforeDestroy : function () {
        $('#datatable').DataTable({
            destroy: true
        });
    }
};
</script>

<style>

</style>
